

import React from 'react';

import './style.css'


interface IModalProps {
    icon : string,
    message: string,
    isOpen: boolean,
    isShowOkButton: boolean,
    onClose: () => void
}

const ImportingModal: React.FC<IModalProps> = ({message, icon, isOpen = false, isShowOkButton = false, onClose  }) => {


    if (!isOpen) {
        return null;
      }
    
      return (
        <div className="modal-overlay">
          <div className="modal-content" style={{minWidth: '500px'}}>
            <div className='center-middle'>
                <div className="icon-size-2">
                    <img className="responsive-image" src={icon} />
                </div>
            </div>
            <br />
            <div className='center-middle font-size-17px'>
               {message}
            </div>
            <br />
              {isShowOkButton && (
                  <div className="center-middle">
                      <button type="button" className="btn-green-2 center-middle" onClick={onClose}>
                          Ok
                      </button>
                  </div>
              )}
          </div>
        </div>
      );

}

export default ImportingModal;